import Vue from 'vue';
import Button from './button.vue';

Vue.component(Button.name, Button);
